import ChipListWrapper from './ChipListWrapper';

export default ChipListWrapper;
